var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"d-flex align-items-end logo-container",class:_vm.$data.staticClass || '',staticStyle:{"height":"auto","display":"flex"}},'div',_vm.$data.attrs,false),[_c('img',{staticStyle:{"height":"100px","width":"auto"},attrs:{"src":"/laterna_logo.png","alt":"Logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }